import React, { useState } from "react";
import "./Contact.css";
import TopNavigation from "../components/TopNavigation";
import axios from "axios";

import ContactBanner2 from "../assets/ContactPage_Cover.jpg";

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        companyName: "",
        email: "",
        phone: "",
        contactMethod: "email", // Default to email
        vision: "",
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await axios.post(
                "https://micahalyse.com/sendEmail.php",
                formData
            );
            alert("Your message has been sent successfully!");
            setFormData({
                firstName: "",
                lastName: "",
                companyName: "",
                email: "",
                phone: "",
                contactMethod: "email",
                vision: "",
            });
        } catch (error) {
            console.error("Error sending email:", error);
            alert("Failed to send the message. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="app">
            <TopNavigation />

            <div className="contact-page">
                <section className="contact-form-section">
                    <div className="form-container">
                        <h1>let's <br /> get <br /> started</h1>
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <div className="input-container">
                                    <label>First Name*</label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="input-container">
                                    <label>Last Name*</label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="input-container">
                                <label>Company Name</label>
                                <input
                                    type="text"
                                    name="companyName"
                                    value={formData.companyName}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="input-container">
                                <label>Email*</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="input-container">
                                <label>Number</label>
                                <input
                                    type="text"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Preferred Contact</label>
                                <div className="radio-options">
                                    <label>
                                        <input
                                            type="radio"
                                            name="contactMethod"
                                            value="email"
                                            checked={formData.contactMethod === "email"}
                                            onChange={handleChange}
                                        />{" "}
                                        Email
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="contactMethod"
                                            value="phone"
                                            checked={formData.contactMethod === "phone"}
                                            onChange={handleChange}
                                        />{" "}
                                        Phone
                                    </label>
                                </div>
                            </div>
                            <div className="input-container">
                                <label>What is your vision?</label>
                                <textarea
                                    name="vision"
                                    value={formData.vision}
                                    onChange={handleChange}
                                    rows="4"
                                ></textarea>
                            </div>
                            <button
                                type="submit"
                                className="submit-button"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Submitting..." : "Submit"}
                            </button>
                        </form>
                    </div>
                    <div className="contact-image">
                        <img src={ContactBanner2} alt="Placeholder" />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Contact;
